<div class="PGGroupWidget">
    @if (isLoading) {
        <app-pg-loading></app-pg-loading>
    }
    @if (!isLoading && groupData != null) {
        <div>
            <div><b>{{ 'pg-group-widget.group' | locTranslate }}</b> {{groupData.id}}{{groupData.label != null && groupData.label != '' ? ' - ' + groupData.label : ''}}</div>
        </div>
    }
</div>
